import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableCell,
  TableContainer,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { StyledTableBody, TableBodyRow } from "../../styles/TableStyles";

const ViewBuildingDialog = ({ open, onClose, building }) => {
  if (!building) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#ffedbb" }}>
        Building Details
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>

      <Divider />

      <DialogContent sx={{ backgroundColor: "#f9f9f9" }}>
        <TableContainer>
          <Table size="small" aria-label="building details table">
            <StyledTableBody>
              <TableBodyRow>
                <TableCell>ID</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>:</TableCell>
                <TableCell>{building.id}</TableCell>
              </TableBodyRow>

              <TableBodyRow>
                <TableCell>Name</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>:</TableCell>
                <TableCell>{building.building_name}</TableCell>
              </TableBodyRow>

              <TableBodyRow>
                <TableCell>Address</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>:</TableCell>
                <TableCell>{building.building_address}</TableCell>
              </TableBodyRow>
            </StyledTableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewBuildingDialog;
